export default __webpack_public_path__ + "img/pin_icons/medgas_manifold_w.svg";